import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiToggleButton: Components<Theme>['MuiToggleButton'] = {
  styleOverrides: {
    root: {
      border: 'none',
      borderRadius: '50%',
      padding: '6px',
      transition: 'background-color 0.1s ease-in',
      height: 'var(--input-height-medium)',
      width: 'var(--input-height-medium)',

      variants: [
        {
          props: { color: 'primary' },
          style: {
            backgroundColor: scssVariables.ColorSoftPink,
            '.icon': {
              color: `${scssVariables.ColorDarkPink} !important`,
            },
            ':hover': {
              backgroundColor: `color-mix(in srgb, ${scssVariables.ColorLightPink} 40%, transparent)`, // add opacity to hex color
            },
            '&.Mui-selected': {
              backgroundColor: `color-mix(in srgb, ${scssVariables.ColorLightPink} 60%, transparent)`, // add opacity to hex color
              ':hover': {
                backgroundColor: `color-mix(in srgb, ${scssVariables.ColorLightPink} 40%, transparent)`, // add opacity to hex color
              },
            },
          },
        },
        {
          props: { color: 'secondary' },
          style: {
            ':hover': {
              backgroundColor: scssVariables.ColorLightLavenderGrey,
            },
            '&.Mui-selected': {
              backgroundColor: scssVariables.ColorLavenderGrey,
              color: scssVariables.ColorBlack,
              ':hover': {
                backgroundColor: scssVariables.ColorLightLavenderGrey,
              },
            },
          },
        },
        {
          props: { size: 'small' },
          style: {
            height: 'var(--input-height-small)',
            width: 'var(--input-height-small)',

            '.MuiToggleButtonGroup-root &': {
              height:
                'calc(var(--input-height-small) - var(--spacing-unit-half))',
              width:
                'calc(var(--input-height-small) - var(--spacing-unit-half))',
            },
          },
        },
        {
          props: { size: 'large' },
          style: {
            height: 'var(--input-height-large)',
            width: 'var(--input-height-large)',
          },
        },
      ],
    },
  },
};
